export default {
  admin: {
    moderate: "/admin/moderate",
    moderationPhases: "/admin/configure/moderation/phases",
    addExternalModerationPhase: "/admin/configure/moderation/phases/add",
    configureExternalModerationPhase: "/admin/configure/moderation/phases",
    webhooks: "/admin/configure/webhooks",
    addWebhookEndpoint: "/admin/configure/webhooks/add",
    configureWebhookEndpoint: "/admin/configure/webhooks/endpoint",
    configureModeration: "/admin/configure/moderation",
  },
  embed: {
    stream: "/embed/stream",
    auth: "/embed/auth",
    deleteAccount: "/embed/deleteAccount",
  },
};
